module.exports = __webpack_public_path__ + "static/img/jiantou.2f2d9be3.png";